<template>
    <div :id="'radio--' + component_id">
        <div v-show="options_loaded && passed_filter && panel_required">
            <div class="radiooption stylesoption" v-if="!loading" :data-designer-component-id="component_id">
                <span>Cylinder Guard: </span>
                <span v-for="option in filtered_option_list"><label><input type="radio" v-model="localTarget"
                                                                           :name="'radio_' + component_id"
                                                                           :value="option.value"/> {{ option.label }}</label></span>
            </div>
            <div v-if="loading">
                <p>Loading Options</p>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import RadioQuestion from "./mixin/RadioQuestion.vue";

    export default {
        mixins: [
            RadioQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Cylinder Guard:';
                }
            },
            component_id: {
                default(){
                    return 'cylinder_guard';
                }
            },
            hardwareColour: {
                required: true
            },
            hardwareCylinder: {
                required: true
            },
            securedByDesign: {
                default(){
                    return '1';
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready(this.hardwareCylinder, this.hardwareColour, this.securedByDesign);
            },
            url(){
                return '/api/options/' + this.fabricator + '/cylinder-guard?hardware_cylinder=' + this.hardwareCylinder + '&hardware_colour=' + this.hardwareColour + '&secured_by_design=' + this.securedByDesign;
            },
            cache_key(){
                return '_' + this.hardwareCylinder + '_' + this.hardwareColour + '_' + this.securedByDesign;
            },
            panel_required(){
                return this.filtered_option_list.length > 1;
            }
        },
        watch: {
            'hardwareColour': function (val, oldVal) {
                this.update_options();
            },
            'hardwareCylinder': function (val, oldVal) {
                this.update_options();
            },
            'securedByDesign': function (val, oldVal) {
                this.select_first_after_update = true;
                this.update_options();
            },
        }
    }
</script>
